import { Range } from './Range';

// TODO: in v9, move styled() from Range.jsx to here
export var StyledRange = Range;